// extracted by mini-css-extract-plugin
export default {"root":"style_root__1ALjt","disabled":"style_disabled__2Ifcx"};